import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-eigth-page',
  templateUrl: './eigth-page.component.html',
  styleUrls: ['./eigth-page.component.css']
})
export class EigthPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
